function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 108,
  height: 32,
  fill: "#000",
  rx: 4
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#A6A6A6",
  fillRule: "evenodd",
  d: "M4 0h100a4 4 0 014 4v24a4 4 0 01-4 4H4c-2.21 0-4-1.79-4-4V4c0-2.21 1.79-4 4-4zm103.36 4A3.36 3.36 0 00104 .64H4A3.36 3.36 0 00.64 4v24A3.36 3.36 0 004 31.36h100a3.36 3.36 0 003.36-3.36V4z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5,
  d: "M37.936 8.192a2.177 2.177 0 01-.6 1.6c-.46.475-1.1.73-1.76.704a2.398 2.398 0 01-1.768-.72 2.551 2.551 0 010-3.568 2.528 2.528 0 012.752-.52c.288.119.546.302.752.536l-.424.424a1.601 1.601 0 00-1.312-.576 1.92 1.92 0 101.344 3.304c.244-.268.386-.613.4-.976h-1.744v-.576h2.328c.018.122.029.245.032.368v0zm3.664-2h-2.16v1.52h1.968v.576H39.44v1.52h2.16v.592h-2.784V5.6H41.6v.592zm2.624 4.208h-.616V6.192h-1.344V5.6H45.6v.592h-1.376V10.4zm3.728 0V5.6h.616v4.8h-.616zm3.352 0h-.616V6.192h-1.344V5.6h3.296v.592h-1.336V10.4z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M57.128 10.505c.66 0 1.293-.262 1.76-.73.47-.468.725-1.111.704-1.775a2.458 2.458 0 00-.704-1.776 2.398 2.398 0 00-1.76-.728 2.345 2.345 0 00-1.76.728 2.592 2.592 0 000 3.552c.467.467 1.1.73 1.76.73zm0-.584c-.49 0-.96-.196-1.304-.545a2.031 2.031 0 010-2.752 1.83 1.83 0 012.608 0 2.031 2.031 0 010 2.752 1.83 1.83 0 01-1.304.545z",
  clipRule: "evenodd"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M58.888 9.776l-.176-.177.176.177zM59.592 8l-.25-.006v.014l.25-.008zm-.704-1.776l-.18.174.002.001.178-.175zm-1.76-.728l-.007.25h.011l-.004-.25zm-1.76.728l-.181-.172h-.001l.182.172zm0 3.552l-.182.171.005.006.177-.177zm.456-.4l-.184.17.006.006.178-.176zm0-2.752l-.178-.176-.006.007.184.169zm2.608 0l.184-.17-.006-.006-.178.176zm0 2.752l.178.176.006-.007-.184-.17zm.28.223c-.42.42-.99.656-1.584.656v.5c.727 0 1.423-.288 1.937-.802l-.354-.354zm.63-1.591c.02.595-.21 1.17-.63 1.59l.352.355a2.65 2.65 0 00.778-1.961l-.5.016zm-.632-1.609c.417.425.645 1 .632 1.595l.5.011a2.706 2.706 0 00-.776-1.956l-.356.35zm-1.578-.653a2.152 2.152 0 011.577.652l.358-.348a2.645 2.645 0 00-1.943-.804l.008.5zm-1.583.65c.409-.43.98-.666 1.572-.65l.014-.5a2.592 2.592 0 00-1.948.806l.362.344zm.001 3.209a2.343 2.343 0 010-3.21l-.364-.342a2.84 2.84 0 000 3.894l.364-.342zm1.578.65a2.238 2.238 0 01-1.583-.656l-.354.354c.514.514 1.21.802 1.937.802v-.5zm-1.482-.703c.391.396.925.62 1.482.62v-.5a1.58 1.58 0 01-1.126-.472l-.356.352zm-.006-3.097a2.28 2.28 0 000 3.09l.368-.338a1.782 1.782 0 010-2.414l-.368-.338zm1.488-.626c-.557 0-1.09.223-1.482.62l.356.35c.297-.3.703-.47 1.126-.47v-.5zm1.482.62a2.08 2.08 0 00-1.482-.62v.5c.423 0 .829.17 1.126.47l.356-.35zm.006 3.096a2.28 2.28 0 000-3.09l-.368.338a1.782 1.782 0 010 2.414l.368.338zm-1.488.626c.557 0 1.09-.223 1.482-.62l-.356-.35c-.297.3-.703.47-1.126.47v.5z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5,
  d: "M60.464 10.4V5.6h.744l2.336 3.736v0V5.6h.616v4.8h-.64l-2.44-3.912V10.4h-.616z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M38.192 18.448v1.44h3.456a3.015 3.015 0 01-.8 1.816 3.537 3.537 0 01-2.672 1.056 3.841 3.841 0 010-7.68 3.708 3.708 0 012.624 1.032l1.016-1.016a5.037 5.037 0 00-3.624-1.456 5.286 5.286 0 00-4.75 7.987 5.284 5.284 0 004.75 2.58 4.853 4.853 0 003.688-1.48 4.796 4.796 0 001.248-3.383c.003-.3-.021-.6-.072-.896h-4.864zm8.864-1.048a3.408 3.408 0 103.416 3.4 3.353 3.353 0 00-3.416-3.4zm4.056 3.416a3.408 3.408 0 013.4-3.416 3.35 3.35 0 013.416 3.4 3.409 3.409 0 01-6.816.016zm1.394.879a2.064 2.064 0 002.006 1.169 1.969 1.969 0 001.92-2.064 2.064 2.064 0 10-3.926.895zm-7.456 0a2.064 2.064 0 002.006 1.169 1.969 1.969 0 001.92-2.064 2.064 2.064 0 10-3.926.895zM71.528 17.4a3.2 3.2 0 012.912 2.168l.168.352-4.552 1.88a1.721 1.721 0 001.648 1.032 1.93 1.93 0 001.672-.936l1.16.8a3.384 3.384 0 01-6.208-1.896 3.196 3.196 0 01.864-2.393 3.195 3.195 0 012.336-1.007zM69.8 20.704a1.87 1.87 0 011.784-1.992 1.313 1.313 0 011.256.728l-3.04 1.264zM67.6 24h-1.496V14H67.6v10zm-3.944-5.84H63.6a2.353 2.353 0 00-1.792-.8 3.408 3.408 0 000 6.808 2.304 2.304 0 001.792-.8h.056v.488c0 1.304-.696 2-1.816 2a1.888 1.888 0 01-1.72-1.208l-1.296.536A3.2 3.2 0 0061.84 27.2c1.752 0 3.2-1.032 3.2-3.544V17.6h-1.384v.56zM60 20.804c0 1.09.848 1.992 1.936 2.06A1.905 1.905 0 0063.76 20.8a1.91 1.91 0 00-1.824-2.056A2.064 2.064 0 0060 20.804zM81.448 14h-3.584v10h1.496v-3.792h2.088a3.114 3.114 0 002.88-4.724A3.11 3.11 0 0081.448 14zm-2.088 4.8h2.088l.032.016a1.712 1.712 0 100-3.424h-2.12V18.8zm11.32-1.432a2.79 2.79 0 00-2.664 1.528l1.32.552a1.422 1.422 0 011.368-.728 1.438 1.438 0 011.6 1.288v.096a3.34 3.34 0 00-1.56-.384c-1.424 0-2.88.8-2.88 2.256a2.315 2.315 0 002.488 2.2 2.122 2.122 0 001.904-.976h.048v.8h1.44v-3.848c0-1.752-1.328-2.768-3.032-2.768l-.032-.016zM89.328 22c0 .6.68.848 1.168.848l.032.016a1.809 1.809 0 001.76-1.6 2.65 2.65 0 00-1.36-.336c-.752 0-1.6.272-1.6 1.072zm9.664-4.4l-1.712 4.336h-.048L95.456 17.6h-1.6l2.664 6.064L95 27.032h1.56l4.096-9.432h-1.664zM87.04 24h-1.488V14h1.488v10z",
  clipRule: "evenodd"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#download-google_inline_svg__paint0_linear)",
  d: "M8.352 6.032a1.599 1.599 0 00-.376 1.12v17.696c-.027.408.108.81.376 1.12l.056.064 9.912-9.912v-.24L8.408 5.976l-.056.056z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#download-google_inline_svg__paint1_linear)",
  d: "M21.6 19.424l-3.28-3.304v-.24l3.28-3.304.072.048 3.928 2.224c1.12.632 1.12 1.672 0 2.312l-3.912 2.224-.088.04z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#download-google_inline_svg__paint2_linear)",
  d: "M21.696 19.376L18.32 16l-9.968 9.968a1.296 1.296 0 001.656.056l11.688-6.648"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#download-google_inline_svg__paint3_linear)",
  d: "M21.696 12.624l-11.688-6.64a1.288 1.288 0 00-1.656.048L18.32 16l3.376-3.376z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M21.6 19.304l-11.592 6.6a1.326 1.326 0 01-1.6 0l-.056.056.056.064a1.329 1.329 0 001.6 0l11.688-6.648-.096-.072z",
  opacity: 0.2
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M8.352 25.856A1.598 1.598 0 018 24.728v.12c-.027.408.108.81.376 1.12l.056-.056-.08-.056zM25.6 17.04l-4 2.264.072.072 3.928-2.224A1.4 1.4 0 0026.448 16a1.488 1.488 0 01-.848 1.04z",
  opacity: 0.12
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.008 6.096L25.6 14.96c.432.192.747.579.848 1.04a1.4 1.4 0 00-.848-1.152L10.008 5.984c-1.112-.64-2.032-.112-2.032 1.168v.12c.024-1.28.92-1.808 2.032-1.176z",
  opacity: 0.25
});

var _ref15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "download-google_inline_svg__paint0_linear",
  x1: 13.977,
  x2: -1.896,
  y1: -6.042,
  y2: -1.817,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#00A1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#00BEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#00D2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#00DFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00E3FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "download-google_inline_svg__paint1_linear",
  x1: 27.064,
  x2: 7.712,
  y1: 7.84,
  y2: 7.84,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#FFBD00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "orange"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9C00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "download-google_inline_svg__paint2_linear",
  x1: 8.07,
  x2: -4.699,
  y1: 10.816,
  y2: 32.255,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3A44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C31162"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "download-google_inline_svg__paint3_linear",
  x1: 0.572,
  x2: 6.27,
  y1: 3.279,
  y2: 12.854,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#32A071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#2DA771"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#15CF74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#06E775"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00F076"
})));

function SvgDownloadGoogleinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 32,
    fill: "none",
    viewBox: "0 0 108 32"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

export default SvgDownloadGoogleinline;